import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pop-up-modal',
  templateUrl: './pop-up-modal.component.html',
  styleUrls: ['./pop-up-modal.component.scss']
})
export class PopUpModalComponent implements OnInit {

 
  @Input('responseMessage') responseMessage: string;
  @Output('triggerCloseEvent') closeEvent = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  public closePopUp(): void {
    this.closeEvent.emit();
  }
  continueCheck(){
    this.closeEvent.emit({success: true});
  }
}
